import LoginForm from "../components/LoginForm";

import styles from "./css/login.module.css"

import ide_logo from "../assets/img/logo-ide-livraria-tray.webp"

import { useEffect } from "react";

import background from '../assets/img/banner-ide.png'


export default function Login({ setHeader }) {

  useEffect(() => {
    setHeader(false);
  }, []);

  return (
    <div className={styles.login} style={{ backgroundImage: `url(${background})` }}>
      <div className={styles.logo}>
        <img src={ide_logo} alt="ide logo" />
      </div>

      <LoginForm />
    </div>
  );

}